import { transport } from "@/src/config/apiConfig.js";

export default {
  async startTaskQueue(payload) {
    let res = await transport.post("/api/tasks/queue/start", payload);
    return res.data;
  },

  async getNextTaskQueue(sessionId) {
    const res = await transport.get(`/api/tasks/queue/next`, {
      params: { session_id: sessionId },
    });
    return res.data;
  },

  async completeTask(id) {
    const res = await transport.put(`/api/task/${id}/complete`);
    return res.data;
  },
};
